import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import {ProfileCard} from '../profile';
import './SearchPage.css';
import SearchFilterPane from './SearchFilterPane';
import actions from './search.actions';
import {DocumentTitle, Spinner} from '../widgets';
import {getProviderFilteredResults, getCommunityFilteredResults} from './search.selectors';
import {CommunityCard} from '../community';
import {uiActions} from '../chrome';
import FancyButton from '../widgets/FancyButton';
import UserProfileCard from '../profile/UserProfileCard';

const SEARCH_RESULTS_LIMIT = 20;

export class SearchPage extends Component {
	componentWillMount() {
		const params = new URLSearchParams(window.location.search);
		if (!params.get('category')) {
			// On mount, synchronise search query params from router with store
			this.props.setQuery(decodeURI(this.props.match.params.query || ''));
			this.props.setHiddenQuery('');
			this.props.startSearch();
		} else {
			this.props.setHiddenQuery(decodeURI(this.props.match.params.query || ''));
			this.props.setQuery('');
			this.props.startSearch();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.match &&
			nextProps.match.params &&
			nextProps.match.params.query !== this.props.match.params.query
		) {
			// On router change, synchronise search query params from router with store
			this.props.setQuery(decodeURI(nextProps.match.params.query || ''));
			this.props.startSearch();
		}
	}

	render() {
		const {
			isRetrieving = false,
			screenSize,
			searchFor,
			showInvite,
			isLoggedIn,
			signup,
			recommendations,
			searchMore
		} = this.props;

		const rawResultCount = this.props.results && this.props.results.length;

		// Redirect category page when search term is blank
		if (!isRetrieving && !this.props.match.params.query && !this.props.query) {
			return <Redirect to="/search-category/" />;
		}

		let results;
		switch (this.props.searchFor) {
			default: // fall-through
			case 'provider': // fall-through
			case 'user':
				results = getProviderFilteredResults(this.props);
				break;
			case 'community':
				results = getCommunityFilteredResults(this.props);
				break;
		}

		return (
			<DocumentTitle title={`${decodeURI(this.props.match.params.query || '') || 'Search'} - B2Me`}>
				<main className="SearchPage">
					{results && results.length > 0 ? <SearchFilterPane /> : null}
					<ol className="SearchPage-results">
						{results &&
							searchFor === 'provider' &&
							results.map(result => (
								<ProfileCard
									key={result.uuid}
									size={screenSize === 'mobile' ? 'small' : 'medium'}
									provider={result}
									recommendations={recommendations && recommendations[result.uuid]}
								/>
							))}
						{results &&
							searchFor === 'user' &&
							results.map(result => (
								<UserProfileCard key={result && result.uuid} profile={result} />
							))}
						{results &&
							searchFor === 'community' &&
							results.map(result => <CommunityCard key={result.uuid} community={result} />)}
						{!isRetrieving && !rawResultCount && (
							<div className="SearchPage-noResults">
								<h1>
									We can't find a <em>{decodeURI(this.props.match.params.query || '') || ''}</em>
								</h1>
								<p>
									B2Me is still growing. If you know a{' '}
									<em>{decodeURI(this.props.match.params.query || '') || ''}</em>
									{isLoggedIn ? (
										<span>
											, you can
											<FancyButton className="PageHeader-signup" onClick={showInvite}>
												invite them
											</FancyButton>
											to join.
										</span>
									) : (
										<span>
											, please
											<FancyButton className="PageHeader-signup" onClick={signup}>
												Sign up
											</FancyButton>
											for <em>free</em> and invite them.
										</span>
									)}
								</p>
							</div>
						)}
						{isRetrieving && <Spinner />}
						{!isRetrieving &&
						rawResultCount !== 0 &&
						rawResultCount % SEARCH_RESULTS_LIMIT === 0 ? (
							<div className="SearchPage-showMore">
								<FancyButton onClick={searchMore}>Show more</FancyButton>
							</div>
						) : (
							undefined
						)}
					</ol>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedSearchPage = connect(
	state => ({
		searchFor: state.search.searchFor,
		recommendations: state.search.recommendations,
		results: state.search.results,
		isRetrieving: state.search.isRetrieving,
		communityFilters: state.search && state.search.filters && state.search.filters.communities,
		suburbFilter: state.search && state.search.filters && state.search.filters.suburb,
		screenSize: state.ui.screenSize,
		isLoggedIn: !!(state.session && state.session.current && state.session.current.user)
	}),
	dispatch => ({
		setQuery: query => dispatch(actions.searchSetQuery(query)),
		setHiddenQuery: query => dispatch(actions.hiddenSearchSetQuery(query)),
		startSearch: () => dispatch(actions.performSearch()),
		searchMore: () => dispatch(actions.searchMore()),
		showInvite: () => dispatch(uiActions.uiModal('invite')),
		signup: () => dispatch(uiActions.uiModal('signup'))
	})
)(SearchPage);

export default ConnectedSearchPage;



// WEBPACK FOOTER //
// ./src/search/SearchPage.js